import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { FormatUtils } from '@shared/utils';
import type { Thread } from '@shared/api';
import { MessageAttachment } from './MessageAttachment';

interface MessageProps {
  value: Thread;
  onSaveAttachment: (messageId: string, filename: string) => void;
}

export const Message = (props: MessageProps) => {
  const { t } = useTranslation('messages');

  const sender = props.value.incoming ? t('thread.message.sender.customerService') : t('thread.message.sender.me');
  return (
    <div
      className={clsx('border self-end  border-[#e5e5e5] m-2 p-2 w-[80%]', {
        'bg-[#fcfcfc]': props.value.incoming,
        'bg-[#e5e5e5]': !props.value.incoming,
        '': props.value.read,
      })}
    >
      <div className='mb-2'>
        {FormatUtils.formatDateTimeFromToday(props.value.dateCreated)}, {sender}
      </div>
      <div className='pb-2 mb-2 whitespace-pre-wrap'>{props.value.body}</div>
      <div className='bg-inherit flex -m-2'>
        {props.value.attachments && props.value.attachments.length
          ? props.value.attachments.map((item, idx) => (
              <MessageAttachment
                key={idx}
                className='m-2'
                file={item}
                onSave={() => props.onSaveAttachment(props.value.messageId, item.originalFilename)}
              />
            ))
          : null}
      </div>
    </div>
  );
};
